import { createFileRoute } from "@tanstack/react-router";

import type { FaqItem } from "../../components/faqs/FaqList";
import { FaqList } from "../../components/faqs/FaqList";

export const Route = createFileRoute("/_authed/faqs")({
  component: FaqsPage,
  head: () => ({
    meta: [{ title: "FAQs | NBDC" }],
  }),
});

const faqs: FaqItem[] = [
  {
    question: "How do I reset my API key?",
    answer: (
      <>
        On the Home page, you&apos;ll find your API key displayed with a
        &apos;Reset&apos; button next to it. Click the Reset button and confirm
        in the dialog. Note that resetting your API key will immediately revoke
        your current key, so you&apos;ll need to update it in Cursor.
      </>
    ),
  },
  {
    question: "What should I do if I get authentication errors?",
    answer: (
      <>
        First, verify that you&apos;ve copied the API key correctly and that the
        Override OpenAI Base URL is set properly in Cursor settings. If you
        recently reset your API key, make sure you&apos;re using the new key. If
        problems persist, try resetting your API key and reconfiguring Cursor
        from scratch.
      </>
    ),
  },
  {
    question: "What happened to the other models?",
    answer: (
      <>
        We&apos;ve updated all the models to be "nubank-bdc-coder[1m]", all
        previous identifiers still work but will be processed by the new model
        automatically.
      </>
    ),
  },
];

function FaqsPage() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h1 className="text-3xl font-semibold tracking-tight">FAQs</h1>
        <p className="text-sm text-muted-foreground">
          Answers to common questions about using the custom models.
        </p>
      </div>
      <FaqList items={faqs} />
    </div>
  );
}
